import { render } from "./ViewManifest.vue?vue&type=template&id=8c55cf42&scoped=true&ts=true"
import script from "./ViewManifest.vue?vue&type=script&lang=ts"
export * from "./ViewManifest.vue?vue&type=script&lang=ts"

import "./ViewManifest.vue?vue&type=style&index=0&id=8c55cf42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c55cf42"]])

export default __exports__